module.exports = __webpack_public_path__ + "static/media/air-cnc2.75f38073.png";